// Horário de venda do produto para quem compra na hora (Pedro, 04/11/2026, T-0060, Mass Gourmet: a «Promo de Terça» só
// pode ser pedida de terça às 16h até quarta às 4h). products.sale_hours, no mesmo formato dos dias da semana do «Por
// encomenda» (que limita a data AGENDADA, outra coisa). Nulo ou sem faixa = sem limite. A faixa não passa da meia-noite
// (regra de 23/10): terça 16:00–23:59 e quarta 00:00–04:00 são duas. O minuto do fim vale (23:59 vai até 23:59:59).
// Regra única para o servidor (que recusa o pedido) e o link (que mostra indisponível): quem chama passa o dia da semana
// e os minutos do dia NO FUSO DA LOJA.
export interface FaixaDeVenda {
  start: string;
  end: string;
}
export interface DiaDeVenda {
  dayOfWeek: number;
  ranges: FaixaDeVenda[];
}
export interface HorarioDeVenda {
  weekly: DiaDeVenda[];
}

const DIAS = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];
const minutos = (h: string) => {
  const [a, b] = h.split(":").map(Number);
  return (a ?? 0) * 60 + (b ?? 0);
};

export function temHorarioDeVenda(h: HorarioDeVenda | null | undefined): h is HorarioDeVenda {
  return !!h && Array.isArray(h.weekly) && h.weekly.some((d) => Array.isArray(d.ranges) && d.ranges.length > 0);
}

function faixasDoDia(h: HorarioDeVenda, dia: number): Array<{ inicio: number; fim: number; start: string; end: string }> {
  return h.weekly
    .filter((d) => d.dayOfWeek === dia)
    .flatMap((d) => d.ranges)
    .map((r) => ({ inicio: minutos(r.start), fim: minutos(r.end), start: r.start, end: r.end }))
    .sort((a, b) => a.inicio - b.inicio);
}

/** Pode pedir agora? Sem horário de venda, sempre. */
export function vendaLiberada(h: HorarioDeVenda | null | undefined, dia: number, minutosDoDia: number): boolean {
  if (!temHorarioDeVenda(h)) return true;
  return faixasDoDia(h, dia).some((f) => minutosDoDia >= f.inicio && minutosDoDia <= f.fim);
}

/** A faixa em que está agora, ou a próxima (até 7 dias à frente). `emDias` 0 = hoje. */
export function proximaVenda(
  h: HorarioDeVenda | null | undefined,
  dia: number,
  minutosDoDia: number,
): { emDias: number; dayOfWeek: number; start: string; end: string } | null {
  if (!temHorarioDeVenda(h)) return null;
  for (let k = 0; k <= 7; k++) {
    const d = (dia + k) % 7;
    const f = faixasDoDia(h, d).find((x) => k > 0 || minutosDoDia <= x.fim);
    if (f) return { emDias: k, dayOfWeek: d, start: f.start, end: f.end };
  }
  return null;
}

const hora = (h: string) => {
  const [a, b] = h.split(":");
  return `${Number(a)}h${b && b !== "00" ? b : ""}`;
};

/** «hoje, das 16h às 23h59», «amanhã, das 0h às 4h», «terça, das 16h às 23h59». */
export function textoDoHorarioDeVenda(p: { emDias: number; dayOfWeek: number; start: string; end: string }): string {
  const quando = p.emDias === 0 ? "hoje" : p.emDias === 1 ? "amanhã" : DIAS[p.dayOfWeek];
  return `${quando}, das ${hora(p.start)} às ${hora(p.end)}`;
}
